import React from 'react'
import { Button } from '@dw/helix'
import { css } from '@emotion/core'

const hideInputStyles = css`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`

interface InputButtonProps {
  children?: any
  accept: string
  onChange?: (e?: any) => any
  dataTestid?: string
}

const InputButton: React.FunctionComponent<InputButtonProps> = ({
  children,
  accept,
  onChange,
  dataTestid,
  ...props
}) => (
  <>
    <input
      css={hideInputStyles}
      type="file"
      name="file"
      id="file"
      multiple
      onChange={onChange}
      data-testid={dataTestid}
    />
    <Button {...props} as="label" htmlFor="file">
      {children}
    </Button>
  </>
)

export default InputButton
